import { useMemo } from 'react';

import { useFlag } from 'lane-shared/hooks';
import WebhookTypeDefinition, {
  getAvailableWebhookEvents,
} from 'lane-shared/helpers/webhooks/WebhookType';
import { PropertiesInterface } from 'lane-shared/types/properties/Property';

import { FeatureFlag } from 'constants-flags';

/**
 * Returns the Webhook properties with the subscribable `events` filtered by the
 * channel's feature flags, so flag-gated events (e.g. reservation events) are
 * only offered when enabled.
 */
export function useWebhookProperties(): PropertiesInterface {
  const isReservationWebhookEnabled =
    useFlag(FeatureFlag.ContentReservationEventWebhook, false) ?? false;

  return useMemo(() => {
    const availableEvents = getAvailableWebhookEvents({
      isReservationWebhookEnabled,
    });

    const eventsProperty = WebhookTypeDefinition.properties.events;

    return {
      ...WebhookTypeDefinition.properties,
      events: {
        ...eventsProperty,
        validators: eventsProperty.validators?.map(validator =>
          validator.name === 'In'
            ? { ...validator, value: availableEvents }
            : validator
        ),
      },
    };
  }, [isReservationWebhookEnabled]);
}
